import './index.scss'
import { Link } from 'react-router-dom'


const ProjectPreview = ({ title, excerpt, to, image, skills }) => {
  return (
    <article className="project-preview">
      <h4 className="project-preview__title">{title}</h4>
      {image && (
        <div className="project-preview__media">
          <img src={image} alt={`${title} thumbnail`} />
        </div>
      )}
      {skills && skills.length > 0 && (
        <ul className="project-preview__skills">
          {skills.slice(0, 3).map((skill) => (
            <li key={skill}>{skill}</li>
          ))}
        </ul>
      )}
      <p className="project-preview__excerpt">{excerpt}</p>
      <div className="project-preview__actions">
        <Link to={to} className="btn btn--secondary">See more</Link>
      </div>
    </article>
  )
}

export default ProjectPreview
